import { useState } from 'react'
import IMG_1 from 'assets/images/scooter/series/video-kv-hero-placeholder.png'
import IMG_2 from 'assets/images/scooter/series/video-kv-hero-placeholder_m.png'
import IMG_3 from 'assets/images/scooter/series/img-series-story-bg.png'
import IMG_4 from 'assets/images/scooter/series/img-series-ksp.png'
import IMG_4_2 from 'assets/images/scooter/series/img-series-ksp-mobile.png'
import IMG_5 from 'assets/images/scooter/series/img-series-feature-1.png'

import IMG_6 from 'assets/images/scooter/series/img-series-feature-2.png'
import IMG_7 from 'assets/images/scooter/series/img-series-feature-3.png'
import IMG_8 from 'assets/images/scooter/series/img-series-feature-4.png'
import IMG_9 from 'assets/images/scooter/series/img-series-gallery-1.png'
import IMG_10 from 'assets/images/scooter/series/img-series-gallery-2.png'

import IMG_11 from 'assets/images/scooter/series/img-series-gallery-3.png'
import IMG_12 from 'assets/images/scooter/series/img-series-gallery-4.png'
import IMG_13 from 'assets/images/scooter/series/img-series-gallery-5.png'
import IMG_14 from 'assets/images/scooter/series/img-experience-1.png'
import IMG_15 from 'assets/images/scooter/series/img-experience-1_m.png'

import IMG_16 from 'assets/images/scooter/series/img-series-sub-feature-1.png'
import IMG_17 from 'assets/images/scooter/series/img-series-sub-feature-2.png'
import IMG_18 from 'assets/images/scooter/series/img-series-sub-feature-3.png'
import IMG_19 from 'assets/images/scooter/m2.png'
import IMG_20 from 'assets/images/scooter/m3.png'
import ScooterPlusPopup from './ScooterPlusPopup'
import ScooterUtlityPopup from './ScooterUtlityPopup'
import { URL, OUTER_URL } from '../../utils/Utils'
import './ScooterPlus.scss'

/**
 * @file 고고로 2 플러스 및 고고로 2 유틸리티 차량 화면
 */
function ScooterPlus() {
    const [isPlusPopup, setIsPlusPopup] = useState(false) //(boolean)plus popup open 여부
    const [isUtlityPopup, setIsUtlityPopup] = useState(false) //(boolean)utlity popup open 여부

    return (
        <>
            <ScooterPlusPopup isPlusPopup={isPlusPopup} setIsPlusPopup={setIsPlusPopup} />
            <ScooterUtlityPopup isUtlityPopup={isUtlityPopup} setIsUtlityPopup={setIsUtlityPopup} />
            <div className="series-one pc" style={{ backgroundImage: `url(${IMG_1})` }}>
                <div className="text-box">
                    <div className="sub">The All New</div>
                    <div className="t1">고고로 2 시리즈</div>
                </div>
            </div>
            <div className="series-one mobile" style={{ backgroundImage: `url(${IMG_2})` }}>
                <div className="text-box">
                    <div className="sub">The All New</div>
                    <div className="t1">고고로 2 시리즈</div>
                </div>
            </div>
            <div className="series-two">
                <div>
                    <div className="t1">고고로 2 시리즈</div>
                    <a className="link" href="" onClick={() => window.open(OUTER_URL.GOGORO_HOMPAGE)}>
                        구매문의
                    </a>
                </div>
            </div>
            <div className="series-three">
                <div className="separated-bg" style={{ backgroundImage: `url(${IMG_3})` }} />
                <div className="three-wrap">
                    <div className="describes-one">
                        <span>안정된 승차감.</span> <br />
                        새로운 스타일의 주행을 경험해보세요.
                        <br />
                        단순한 이동 수단을 넘어 일상에 행복을 주는
                        <br />
                        여행 파트너가 될 것입니다.
                    </div>
                    <div className="series-spec">
                        <img className="series-spec-scooter-img pc" src={IMG_4} alt="scooter" />
                        <img className="series-spec-scooter-img mobile" src={IMG_4_2} alt="scooter" />
                        <div className="spec-box">
                            <div>
                                <div className="point">
                                    <span>125</span>cc
                                </div>
                                <div className="label label-text">등급</div>
                            </div>
                            <div>
                                <div className="point">
                                    <span>6.4</span>kw
                                </div>
                                <div className="label label-text">최대전력</div>
                            </div>
                            <div>
                                <div className="point">
                                    <span>SBS</span>
                                </div>
                                <div className="label label-text">브레이크 시스템</div>
                            </div>
                        </div>
                    </div>
                    <div className="describes-two">
                        <div className="t1">
                            세련된 디자인의 차량은
                            <br />
                            당신을 더욱 트렌디하게 합니다.
                        </div>
                    </div>
                    <div className="part-details">
                        <div className="one">
                            <img src={IMG_5} alt="" />
                            <div className="text-box">
                                <div className="t1">뛰어난 파워와 자신감</div>
                                <div className="sub">
                                    수냉식 기술이 적용된 고효율 모터에서 나오는 부드러운 출력과 주행
                                </div>
                            </div>
                        </div>
                        <div className="two">
                            <img src={IMG_6} alt="" />
                            <div className="text-box">
                                <div className="t1">부드러운 성능</div>
                                <div className="sub">조용하고 편안한 카본벨트와 안전하고 강한 골드 체인</div>
                            </div>
                        </div>
                        <div className="three">
                            <img src={IMG_7} alt="" />
                            <div className="text-box">
                                <div className="t1">안정적인 제동 성능</div>
                                <div className="sub">SBS 브레이크를 적용해 안전한 주행을 지원합니다.</div>
                            </div>
                        </div>
                        <div className="four">
                            <img src={IMG_8} alt="" />
                            <div className="text-box">
                                <div className="t1">안정감 있는 주차</div>
                                <div className="sub">
                                    기하학적 디자인으로 만들어진 인체공학적 레버로
                                    <br />
                                    쉽게 주차할 수 있습니다.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="describes-three">
                        <div className="t1">눈을 사로잡는 심플하고 유연한 디자인을 만나보세요</div>
                    </div>
                    <div className="grid-box">
                        <div>
                            <div className="img" style={{ backgroundImage: `url(${IMG_9})` }} />
                        </div>
                        <div>
                            <div className="img" style={{ backgroundImage: `url(${IMG_10})` }} />
                        </div>
                        <div>
                            <div className="img" style={{ backgroundImage: `url(${IMG_11})` }} />
                        </div>
                        <div>
                            <div className="img" style={{ backgroundImage: `url(${IMG_12})` }} />
                        </div>
                        <div>
                            <div className="img" style={{ backgroundImage: `url(${IMG_13})` }} />
                        </div>
                    </div>
                    <div className="user-experience">
                        <img className="pc" src={IMG_14} alt="" />
                        <img className="mobile" src={IMG_15} alt="" />
                        <div className="t1 pc">화려한 디스플레이</div>
                        <div className="text-box">
                            <div className="t1 mobile"> 스펙타클한 디스플레이</div>
                            <div className="t1">커스텀 컬러 설정</div>
                            <div className="sub">
                                모바일 앱을 통해 대시보드의 색상을 개성에 따라 자유롭게 설정하세요
                            </div>
                        </div>
                    </div>
                    <div className="gogoro-app">
                        <div className="t1">IQ6 System</div>
                        <div className="sub">스마트 드라이빙 기술로 주행을 보다 안전하고 간단하게 만들어줍니다.</div>
                        <a className="link" href={URL.APPLICATION}>
                            더 알아보기 &gt;
                        </a>
                    </div>
                    <div className="extra-describes">
                        <div>
                            <img src={IMG_16} alt="" />
                            <div className="t1">바이오 인증</div>
                            <div className="sub">생체 인증을 통해 보안을 강화합니다</div>
                        </div>
                        <div>
                            <img src={IMG_17} alt="" />
                            <div className="t1">기상 감지 모드</div>
                            <div className="sub">
                                기상을 감지하고 트랙션 제어를 위해 차량 토크를 자동으로 조정합니다
                            </div>
                        </div>
                        <div>
                            <img src={IMG_18} alt="" />
                            <div className="t1">원클릭 후진 기능</div>
                            <div className="sub">편리한 후진 기능을 지원합니다</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="series-four">
                <div className="t1 pc">고고로 2 시리즈</div>
                <div className="s2-motors-wrapper">
                    <div>
                        <img data-href="plus" src={IMG_19} alt="" onClick={() => setIsPlusPopup(true)} />
                        <div className="colors mobile">
                            <span style={{ backgroundColor: '#E5E5E5' }} />
                            <span style={{ backgroundColor: '#474747' }} />
                        </div>
                        <div className="t1">고고로 2 플러스</div>
                        <div className="sub">안정적인 승차감</div>
                        <div className="colors pc">
                            <span style={{ backgroundColor: '#E5E5E5' }} />
                            <span style={{ backgroundColor: '#474747' }} />
                        </div>
                    </div>
                    <div>
                        <img data-href="utility" src={IMG_20} alt="" onClick={() => setIsUtlityPopup(true)} />
                        <div className="colors mobile">
                            <span style={{ backgroundColor: '#474747' }} />
                        </div>
                        <div className="t1">고고로 2 유틸리티</div>
                        <div className="sub">비즈니스를 위한 선택</div>
                        <div className="colors pc">
                            <span style={{ backgroundColor: '#474747' }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterPlus
